
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Device } from '@/types/catalogs/Devices'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import { MessageError } from '@/components/generic/MessageHandling.vue'
import catalogsService from '@/services/CatalogsService'
import DateFormat from '@/services/DateFormat'

@Component({
  components: {
    LoadingMask
  }
})
export default class AdminDeviceForm extends Vue {
  @Prop({ required: true, default: 0 })
  id: number

  @Prop({ required: true, default: '' })
  title: string

  @Prop({ required: false, default: false })
  readOnly: boolean

  @Prop({ required: false, default: false })
  canRefresh: boolean

  @Prop({ required: false, default: false })
  canDelete: boolean

  @Prop({ required: false, default: '' })
  user: string

  loading: boolean = false
  form: Device = Device.getInstanceForEdit()
  statusDevice = ''
  creationDate = ''
  updateDate = ''

  mounted () {
    if (this.id) {
      this.loading = true
      this.loadDevice()
    }
  }

  /**
   * GET a device by id, it query Users API
   * @param id - device
   */
  async getDevice (id: number) {
    await catalogsService.getDeviceById(id).then(data => {
      Object.assign(this.form, data)
      this.statusDevice = Device.getStatus(this.form.status)
      this.creationDate = data.creationDate ? new DateFormat(data.creationDate).toDateTimeString() : '- - / - - / - - - -'
      this.updateDate = data.updateDate ? new DateFormat(data.updateDate).toDateTimeString() : '- - / - - / - - - -'
    }).catch((error) => {
      let errorValues = {
        title: 'Error al cargar dispositivo',
        message: '',
        delay: 10000,
        error: error
      }
      new MessageError({ propsData: errorValues }).displayMessage()
    }).finally(() => {
      this.loading = false
    })
  }

  /**
   * Call getDevice with id from form
   */
  loadDevice () {
    this.getDevice(this.id)
  }

  /**
   * Emit event to remove item
   */
  deleteItem () {
    this.$emit('delete-item')
  }

  /**
   * Close form view
   */
  onCancel () {
    this.$emit('close')
  }
}
